import {ScorecardRow} from "./row";
import {ScorecardRow as ScorecardRowModel} from "../model/scorecard-model";
import {arrayOrEmpty} from "../../../common/extensions/array";

export function getTeamScoreRow(row: ScorecardRowModel<string, string>): ScorecardRow {
    return {
        name: "Team",
        outValues: row.outValues,
        outTotal: row.outTotal,
        inValues: arrayOrEmpty(row.inValues),
        inTotal: row.inTotal,
        total: row.total,
        classes: ""
    };
}

